const { UPDATE_BREADCRUMB } = require('constants/actionTypes');
const breadcrumb = (activeCrumbData) => {
  return (dispatch) => {
    dispatch(success(activeCrumbData));
  };

  function success(data) {
    return { type: UPDATE_BREADCRUMB, payload: data };
  }
};

export const breadcrumbActions = {
  breadcrumb
};
